import request from '@/utils/request'

export const NOTICE_KEY = 'bucket'

export interface PurchaseNoticeItem {
  label: string
  text: string
}

export interface PurchaseNoticeSection {
  title: string
  items: PurchaseNoticeItem[]
}

export interface PurchaseNotice {
  id?: number
  storeId?: number | null
  noticeKey: string
  title: string
  sections: PurchaseNoticeSection[]
  status?: number
  updateTime?: string
}

export const getPurchaseNoticeList = (storeId?: number | null) => {
  return request({
    url: '/purchaseNotice/list',
    method: 'get',
    params: storeId != null ? { storeId } : {}
  })
}

export const updatePurchaseNotice = (data: PurchaseNotice) => {
  return request({
    url: '/purchaseNotice',
    method: 'put',
    data
  })
}
